import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import './DeviceCard.css';

// Registramos los componentes necesarios para Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        color: '#ffffff', // Color de las etiquetas de la leyenda
        font: {
          family: "'Share Tech Mono', monospace",
        },
      },
    },
    title: {
      display: false,
    },
  },
  layout: {
    padding: {
        bottom: 10 // Reservamos un poco de espacio, menos que en el modal
    }
  },
  scales: {
    x: {
      ticks: {
        color: '#ccc', // Color de las etiquetas del eje X
        font: {
          family: "'Share Tech Mono', monospace",
        },
        maxTicksLimit: 6, // Limita las etiquetas para evitar superposición
      },
      grid: {
        color: 'rgba(255, 255, 255, 0.1)', // Color de la rejilla X
      },
    },
    y: {
      beginAtZero: true,
      max: 100, // El uso es un porcentaje
      ticks: {
        color: '#ccc', // Color de las etiquetas del eje Y
        font: {
          family: "'Share Tech Mono', monospace",
        },
      },
      grid: {
        color: 'rgba(255, 255, 255, 0.1)', // Color de la rejilla Y
      },
    },
    y1: { // Eje secundario para la temperatura
      type: 'linear',
      display: true,
      position: 'right',
      ticks: {
        color: '#39ff14', // Color de las etiquetas del eje de Temp
        font: {
          family: "'Share Tech Mono', monospace",
        },
      },
      grid: {
        drawOnChartArea: false, // No dibujar la rejilla para este eje
      },
    },
  },
};

const DeviceCard = ({ deviceStatus, deviceName, onSelectDevice, chartData }) => {
  if (!deviceStatus) {
    return <div className="device-card">Cargando dispositivo...</div>;
  }
  
  const statusClassName = deviceStatus.isOnline ? 'online' : 'offline';

  const lastSeenFormatted = typeof deviceStatus.lastSeen === 'number'
    ? new Date(deviceStatus.lastSeen).toLocaleString()
    : deviceStatus.lastSeen || 'N/A';

  return (
    <div className="device-card clickable" onClick={() => onSelectDevice(deviceStatus)}>
      <div className="device-header">
        <h3>{deviceName || 'Dispositivo Desconocido'}</h3>
        <span className={`status-indicator ${statusClassName}`}></span>
      </div>
      <div className="device-body">
        <p>Estado: <span className={statusClassName}>{deviceStatus.isOnline ? 'En línea' : 'Desconectado'}</span></p>
        <p>Última conexión: {lastSeenFormatted}</p>
        <div className="chart-container" style={{ height: '250px' }}>
          <h4>Telemetría</h4>
          <Line data={chartData} options={chartOptions} />
        </div>
      </div>
    </div>
  );
};

DeviceCard.propTypes = {
  deviceStatus: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isOnline: PropTypes.bool,
    lastSeen: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    type: PropTypes.string,
    telemetry: PropTypes.object 
  }),
  deviceName: PropTypes.string,
  onSelectDevice: PropTypes.func.isRequired,
  chartData: PropTypes.object.isRequired,
};

export default DeviceCard;
